import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as RangeWithIdList from 'types/Ingredient/Search/RangeWithIdList';

const rb = new ReducerBuilder<RangeWithIdList.Type>();
export const createIngredientRangesReducerLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'Ingredients/LoadedFromBackend'
);

export const ingredientRangesReducer = rb.createReducer();
